module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "pxi"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGEMENTS")])])]), _c('a', {
    attrs: {
      "id": "pxi"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("A special thanks")]), _vm._v(" goes to my husband, Jonathon Beamer, for giving me inspiration, vision and expertise throughout this project. I think I would have abandoned the work if you had not been that constant voice of encouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you, Jillian Freeland, Liesa Glander and Jennifer Villarreal for freely giving of yourselves to edit and provide feedback. Your support is greatly appreciated.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc40c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 78
// module chunks = 0